import { useState } from 'react';
import { PrivacyPolicyModal, CookiePolicyModal, TermsOfServiceModal } from './LegalModals';

export default function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showCookie, setShowCookie] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <footer className="py-16" style={{background:'#EEF2FF'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-3xl p-16 relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-lg transform -rotate-12 -z-10" style={{background:'#1E3A5F'}}></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 rounded-lg transform rotate-6 -z-10" style={{background:'#B8860B'}}></div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
              <div>
                <img 
                  src="https://static.readdy.ai/image/ad756da4025d31f1ae7a1f7a866a3119/3d98b04b0600f3ac5caaf149bd10d081" 
                  alt="PM Resources srl" 
                  className="h-10 w-auto object-contain mb-4"
                />
                <p className="text-sm text-gray-600 leading-relaxed mb-3">
                  Il tuo partner per soluzioni HR professionali
                </p>
                <p className="text-xs text-gray-500 leading-relaxed">
                  Esternalizzazione, ricerca e consulenza per aziende che vogliono crescere con il giusto team.
                </p>
              </div>

              <div>
                <h4 className="text-xs font-bold text-gray-900 tracking-wider mb-4">SERVIZI</h4>
                <ul className="space-y-3">
                  {['Ricerca Personale','Outsourcing','Consulenza HR','Formazione','Temporary Management'].map(s => (
                    <li key={s}>
                      <button onClick={() => scrollToSection('servizi')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                        {s}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-bold text-gray-900 tracking-wider mb-4">AZIENDA</h4>
                <ul className="space-y-3">
                  {[
                    {label:'Chi Siamo', id:'chi-siamo'},
                    {label:'Metodologia', id:'soluzioni'},
                    {label:'Case Studies', id:'chi-siamo'},
                    {label:'Settori', id:'servizi'},
                    {label:'Carriere', id:'contatti'},
                  ].map(item => (
                    <li key={item.label}>
                      <button onClick={() => scrollToSection(item.id)} className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-bold text-gray-900 tracking-wider mb-4">CONTATTI</h4>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-2">
                    <i className="ri-mail-line text-base mt-0.5" style={{color:'#1E3A5F'}}></i>
                    <a href="mailto:pmresources.srl@gmail.com" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                      pmresources.srl@gmail.com
                    </a>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-map-pin-line text-base mt-0.5" style={{color:'#1E3A5F'}}></i>
                    <span className="text-sm text-gray-600">Viale Antonio Ciamarra 222, Roma</span>
                  </li>
                </ul>
                <button 
                  onClick={() => scrollToSection('contatti')}
                  className="w-full px-4 py-3 text-white text-sm font-semibold rounded-lg hover:opacity-90 transition-all whitespace-nowrap cursor-pointer"
                  style={{background:'#1E3A5F'}}
                >
                  Richiedi Preventivo
                </button>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="text-xs text-gray-500">
                  © 2025 PM Resources srl | P.IVA 12345678901
                </div>
                <div className="flex items-center gap-6 text-xs text-gray-500">
                  <button onClick={() => setShowPrivacy(true)} className="hover:text-gray-900 transition-colors cursor-pointer">Privacy Policy</button>
                  <span>|</span>
                  <button onClick={() => setShowCookie(true)} className="hover:text-gray-900 transition-colors cursor-pointer">Cookie Policy</button>
                  <span>|</span>
                  <button onClick={() => setShowTerms(true)} className="hover:text-gray-900 transition-colors cursor-pointer">Termini di Servizio</button>
                </div>
                <div className="flex items-center gap-3">
                  <a 
                    href="https://www.linkedin.com/feed/" 
                    target="_blank" 
                    rel="noopener noreferrer nofollow"
                    className="w-9 h-9 rounded-full flex items-center justify-center hover:opacity-80 transition-colors cursor-pointer"
                    style={{background:'#1E3A5F'}}
                  >
                    <i className="ri-linkedin-fill text-white text-base"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showPrivacy && <PrivacyPolicyModal onClose={() => setShowPrivacy(false)} />}
      {showCookie && <CookiePolicyModal onClose={() => setShowCookie(false)} />}
      {showTerms && <TermsOfServiceModal onClose={() => setShowTerms(false)} />}
    </>
  );
}